import React from 'react';
import { connect } from 'react-redux';
import Flag from 'react-world-flags'

import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import SelectBox from '../../modules/SelectBox';

import * as servicesActions from '../../../actions/services';
import * as sessionApi from '../../../services/api/session';

import styles from './styles.scss';

class Services extends React.Component {

    constructor() {
        super();

        this._changeCountryCode = this._changeCountryCode.bind(this);
    }

    componentDidMount() {

        sessionApi
            .getCountryCode()
            .then((res) => {
                const countryCode = res.payload;
                this.props.updateSelectedCountry(countryCode);
                this.props.refreshAllServices({ filterByCountryCode: countryCode });
            });
    }

    _changeCountryCode(event) {
        event.preventDefault();
        this.props.updateSelectedCountry(event.target.value);
        this.props.refreshAllServices({ filterByCountryCode: event.target.value });
    }

    render() {

        const { selectedCountryCode } = this.props;

        return (
            <Page>
                <PageMeta title="My Services" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageHeader>
                        <h1>My Services</h1>

                        <span>Access your RHE Global services from one place.</span>
                    </PageHeader>

                    {selectedCountryCode &&
                        <PageSection>
                            <div>
                                <div className={styles['flag-container']}>
                                    <Flag code={selectedCountryCode} />
                                </div>

                                <SelectBox
                                    containerClassName={styles['country-dropdown']}
                                    onChange={this._changeCountryCode}
                                    aria-label='Country Selection'
                                    label={'Country'}
                                    input={{ name: 'country_code', value: selectedCountryCode || '' }}
                                >
                                    <option value="GB">United Kingdom</option>
                                    <option value="AU">Australia</option>
                                    <option value="TH">Thailand</option>
                                </SelectBox>
                            </div>
                        </PageSection>
                    }

                    {this.props.services.length > 0 &&
                        <PageSection>
                            {this.props.services.map(service => {
                                return (
                                    <a
                                        href={service.service_url}
                                        className={styles['service-tile']}
                                        key={service.id}
                                    >
                                        <div className={styles['logo-wrapper']}>
                                            <img className={styles['service-logo']} src={service.logo_url} alt={service.name}/>
                                            <h2 className={styles['service-name']}>{ service.name }</h2>
                                        </div>
                                    </a>
                                )
                            })}
                        </PageSection>
                    }

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.services
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateSelectedCountry(countryCode) {
            dispatch(servicesActions.updateSelectedCountry(countryCode));
        },
        refreshAllServices(params) {
            dispatch(servicesActions.refreshAllServices(params));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Services);